<template>
  <el-dialog title="编辑角色" :visible.sync="dialogShow">
    <el-form :model="form" :rules="rules" ref="formRules">
      <el-form-item label="角色代码" :label-width="formLabelWidth" prop="code">
        <el-col :span="10">
          <el-input v-model="form.code" auto-complete="off"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item
        label="角色名称"
        :label-width="formLabelWidth"
        prop="roleName"
      >
        <el-col :span="10">
          <el-input v-model="form.roleName" auto-complete="off"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item
        label="是否锁定"
        :label-width="formLabelWidth"
        prop="isLocked"
      >
        <el-col :span="12">
          <el-select v-model="form.isLocked" placeholder="--请选择--">
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item label="菜单选择" :label-width="formLabelWidth">
        <el-col :span="12">
          <el-tree
            :data="trees"
            show-checkbox
            node-key="id"
            ref="tree"
            highlight-current
            :default-expanded-keys="[2, 3]"
            :default-checked-keys="checkedKeys"
            :props="defaultProps"
          >
          </el-tree>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="submitFrom">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SystemRoleEdit",
  props: {
    show: Boolean,
    value: Object,
    formRules: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogShow: this.show,
      systemList: [],
      form: {
        roleName: "",
        isLocked: "",
        systemName: "",
        code: "",
      },
      formLabelWidth: "120px",
      trees: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      checkedKeys: [0],
      rules: {
        code: [
          { required: true, message: "请输入角色代码", trigger: "blur" },
          { min: 1, max: 15, message: "长度在 1 到 15个字符", trigger: "blur" },
        ],
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { min: 3, max: 10, message: "长度在 3 到 10个字符", trigger: "blur" },
        ],
        isLocked: [{ required: true, message: "是否锁定", trigger: "change" }],
        systemName: [
          { required: true, message: "请选择所属平台", trigger: "change" },
        ],
        tree: [
          { required: true, message: "请选择所属平台", trigger: "change" },
        ],
      },
      roleId: "",
    };
  },
  methods: {
    systemNameChange() {
      console.log(this.form.systemName);
      let param = {};
      param.systemIds = this.form.systemName;
      param.roleId = this.roleId;
      this.getMenu(param);
    },
    submitFrom() {
      this.$refs.formRules.validate((valid) => {
        if (valid) {
          let param = {};
          param.code = this.form.code;
          param.name = this.form.roleName;
          param.isLocked = this.form.isLocked;
          param.systemId = this.form.systemName;
          param.id = this.roleId;
          let menus = this.$refs.tree.getCheckedKeys();
          if (menus.length <= 0) {
            this.$notify.error({
              title: "提示",
              message: "请选择一个菜单",
            });
            return;
          }
          param.systemMenu = menus.join("&");

          console.log("param:" + JSON.stringify(param));
          this.$axios.post("/sysRoleInfo/save", param).then((res) => {
            if (res.code === 200) {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "success",
              });
              this.dialogShow = false;
              this.$emit("update:show", false);
              this.$bus.$emit("refresh"); //通知刷新
            } else {
              this.$notify.error({
                title: "提示",
                message: res.msg,
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeDialog() {
      this.dialogShow = false;
      this.$emit("update:show", false);
    },
    getMenu(param) {
      this.$axios
        .get("/sysRouterInfo/selectRouterByRoleForTree", { params: param })
        .then((res) => {
          this.trees = res.trees;
          this.checkedKeys = res.checkedKeys;
        });
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
    },
    value(newVal) {
      console.log("newVal:" + JSON.stringify(newVal));
      this.roleId = newVal.id;

      this.form.code = newVal.code;
      this.form.roleName = newVal.roleName;
      this.form.isLocked = newVal.isLocked;
      this.form.systemName = newVal.systemId;

      let param = {};
      param.roleId = newVal.id;
      param.systemIds = newVal.systemId;
      this.getMenu(param);

      this.dialogShow = true;
      this.$emit("update:show", true);
      if (this.$refs.formRules !== undefined) {
        this.$refs.formRules.clearValidate();
      }
    },
  },
  created() {},
};
</script>

<style scoped>
</style>